// Shortest password every site accepts before the backend: useAuth / useAuthWithEmailMobile check it on sign-up, reset
// and change password, and the sites' own account forms and hints read the same number (owner's rule, 2026-10-27; the
// sites had 8 and useAuth's `validationRules.password` 5 + mixed case).
export const PASSWORD_MIN_LENGTH = 3;
